import { Controller } from 'stimulus';

export default class extends Controller {
  initialize(){
    this.url = this.element.dataset.url
    this.courseId = this.element.dataset.courseId
    this.radio = this.element.querySelector("input[name='certificateClaimInput']")
    this.inputId = this.element.querySelector("input#certificateClaim");

    this.radio.addEventListener('change', this.performRequest.bind(this));

    if (this.element.dataset.checked){
      this.autoChecked();
    }
  }

  autoChecked(){
    this.radio.checked = true;
    const event = new Event('change');
    this.radio.dispatchEvent(event);
  }

  performRequest(){
    window.KTApp.blockPage(this.element, {});
    const dataPost = {
      course_id: this.courseId,
      certificate_claim_id: this.inputId.value
    }
    window.Ajax.post(this.url, this.ajaxOptions(dataPost));
  }

  handleSuccess(response){
    const parsedResponse = JSON.parse(response);
    const modalChild = document.querySelector(`#certificate-payment-${this.element.dataset.courseId}`).firstChild
    modalChild.dataset.url = parsedResponse.url

    const modalController = this.application.getControllerForElementAndIdentifier(
      modalChild,
      "modal--dynamic"
    )
    modalController.performClaimCertificateRequest(modalChild);
    Flash.show("success", parsedResponse.notice)
  }

  handleFail(response){
    const parsedResponse = JSON.parse(response);
    const modalChild = document.querySelector(`#certificate-payment-${this.element.dataset.courseId}`).firstChild
    const modalController = this.application.getControllerForElementAndIdentifier(
      modalChild,
      "modal--dynamic"
    )
    modalController.performClaimCertificateRequest(modalChild);
    Flash.show("danger", parsedResponse.notice)
  }

  handleDone(response){
    window.KTApp.unblockPage();
  }

  ajaxOptions(dataPost){
    return {
      data: JSON.stringify(dataPost),
      headers: [
        {
          key: 'X-CSRF-Token',
          value: window.Util.getCsrfToken()
        },
        {
          key: 'Content-Type',
          value: 'application/json'
        }
      ],
      onSuccess: this.handleSuccess.bind(this),
      onFail: this.handleFail.bind(this),
      onDone: this.handleDone.bind(this)
    }
  }
}